import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';

import { IconName } from '../../atoms';
import { TopMenuLink } from '../../atoms/top-menu-link/top-menu-link';
import { flex } from '../../style-utils';

export type TopMenuItem = {
  name: string;
  onPress: () => void;
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  hoveredTextStyle?: StyleProp<TextStyle>;
  rightIcon?: IconName;
};

export type TopMenuComponent = {
  children?: React.ReactNode;
  onPress?: () => void;
} & TopMenuItem;

export interface TopMenuProps {
  items: TopMenuComponent[];
}

export function TopMenu({ items }: TopMenuProps) {
  return (
    <View style={[flex('flex-1', 'flex-row')]}>
      {items.map((item) =>
        item.children ? (
          <View key={item.name} style={item.containerStyle}>
            {item.children}
          </View>
        ) : (
          <TopMenuLink key={item.name} {...item} />
        )
      )}
    </View>
  );
}
